import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        err: null,

        steps: {},
        step: null,

        data: {},
        // background: 'bg-blue-500',
        // button: 'bg-black',

        configs: {},

        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ],
    },
    mutations: {
        updateField(state, data) {
            state[data.field] = data.value;
        },
        updateData(state, data) {
            Vue.set(state.data, data.field, data.value);
            // state.data[data.field] = data.value;
        }
    },
    getters: {

    },
})
